import "./Login.css";
import email_icon from "../../Assets/email.png";
import password_icon from "../../Assets/password.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ResponseMessage } from "../../models/ResponseMessage";
import { LoginResponse } from "../../models/LoginResponse";
import exclamaiton from "../../Assets/exclamation.png";
import { loginAsync } from "../../api/AccountApi";
import { Link } from "react-router-dom";
import LoadingBar, { LoadingBarRef } from "react-top-loading-bar";
import React, { useRef } from "react";
import { Constants } from "../../constants/constants";
import MfaModal from "../../components/MfaModal";
import { verifyMfaAsync } from "../../api/AccountApi";
import { useAuth } from "../../hooks/useAuth";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoginSucess, setLoginSuccess] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const ref = useRef<LoadingBarRef>(null);
  const [isVerifyMfaShow, setVerifyModal] = useState(false);
  const [isLoginFailed, setLoginFailed] = useState(false);
  const [mfaCode, setMfaCode] = useState("");
  const [token, setToken] = useState("");
  const [userId, setUserId] = useState("");

  const loginFailOk = async () => {
    setLoginFailed(false);
  };

  const verifyMfa = async () => {
    setLoading(true);
    console.log("userid ", userId);
    try {
      const response: ResponseMessage<LoginResponse> = await verifyMfaAsync(
        token,
        mfaCode,
        userId
      );
      if (response.success) {
        setLoading(false);
        localStorage.setItem(
          Constants.ACCESS_TOKEN,
          response.result.accessToken
        );
        ref.current?.complete();
        await refreshUser();
        navigate("/dashboard");
      } else {
        setVerifyModal(false);
        setLoading(false);
        setLoginFailed(true);
        setMfaCode("");
      }
    } catch {}
  };

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please fill all the fields");
      return;
    }
    ref.current?.continuousStart();
    setLoading(true);
    try {
      const response: ResponseMessage<LoginResponse> = await loginAsync(
        email,
        password
      );

      if (response.success) {
        setPassword("");
        ref.current?.complete();
        if (response.result.isMfaRequired) {
          setUserId(response.result.userId);
          console.log("userid ", userId);
          setVerifyModal(true);
          setLoginSuccess(true);
          setLoading(false);
          return;
        }
        localStorage.setItem(
          Constants.ACCESS_TOKEN,
          response.result.accessToken
        );
        setLoginSuccess(true);
        await refreshUser();
        navigate("/dashboard");
      } else {
        setLoginSuccess(false);
        setLoading(false);
        setPassword("");
        ref.current?.complete();
      }
    } catch (error) {
      setLoading(false);
      setPassword("");
      console.error("❌ login failed:", error);
      alert("login  failed. Please try again." + error);
      ref.current?.complete();
    }
  };

  return (
    <div className="container">
      <LoadingBar color="#3498db" ref={ref} height={3} />
      <div className="holder_login">
        <div className="inputs">
          {loading && (
            <div className="loading-overlay">
              <div className="spinner"></div>
            </div>
          )}
          <label className="name">Login</label>
          {isLoginSucess === false && (
            <div className="incorrect_message">
              <img
                className="input-icon"
                src={exclamaiton}
                alt="exclamation icon"
              />
              <p>Username or password incorrect</p>
            </div>
          )}
          <div className="input-wrapper">
            <img className="input-icon" src={email_icon} alt="email icon" />
            <input
              className="input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="input-wrapper">
            <img
              className="input-icon"
              src={password_icon}
              alt="password icon"
            />
            <input
              className="input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="forgot-password">
            <label>
              <Link to="/forget-password">Forget Password? </Link>
            </label>
          </div>
          <div className="login-create-account">
            <button
              className="login-btn"
              disabled={loading}
              onClick={handleLogin}
            >
              Login
            </button>
          </div>
        </div>
      </div>
      {isVerifyMfaShow == true && (
        <MfaModal
          show={isVerifyMfaShow}
          btnName="Verfiy"
          onSave={() => verifyMfa()}
        >
          <h2>Please put six digit code </h2>
          <div className="mfa_modal_image">
            <input
              className="input_mfa"
              placeholder="Enter Code"
              value={mfaCode}
              onChange={(e) => setMfaCode(e.target.value)}
            />
          </div>
        </MfaModal>
      )}

      {isLoginFailed == true && (
        <MfaModal
          show={isLoginFailed}
          btnName="Close"
          onSave={() => loginFailOk()}
        >
          <h2>Login Failed</h2>
        </MfaModal>
      )}
    </div>
  );
};

export default Login;
